import type { VariantCategories } from "./Variant/variantCategories";
import type { VariantState } from "./variantState";

type Input = {
  variantCategories: VariantCategories;
};
type Output = VariantState;
type GetDefaultVariantStore = (input: Input) => Output;

export const getDefaultVariantStore: GetDefaultVariantStore = (input) => {
  const { variantCategories } = input;
  const categories = variantCategories.flatMap(([_, category]) => category);
  const amounts = categories.reduce((previousValue, category) => {
    const { subClass } = category;
    previousValue.set(subClass, 0);
    return previousValue;
  }, new Map());
  const selectedVariantId = categories.at(0)?.subClass;

  return { amounts, selectedVariantId };
};
